import classNames from 'classnames'
import Script from 'next/script'
import { useEffect, useState } from 'react'
import { Persistor } from 'redux-persist/es/types'

import PleaseSupportUs from '@/components/PleaseSupportUs/PleaseSupportUs'
import Toasts from '@/components/Toasts/Toasts'
import useDirectories from '@/utils/useDirectories'
import usePatreonTier from '@/utils/usePatreonTier'

import Footer from './Footer/Footer'
import styles from './Layout.module.scss'
import Leaderboard from './Leaderboard/Leaderboard'
import Navbar from './Navbar/Navbar'
import ScrollToTopButton from './ScrollToTopButton/ScrollToTopButton'

const LEADERBOARD_BLACKLIST = ['newsletter']

const SIDEBAR_BLACKLIST = [
  '',
  'about-us',
  'account',
  'apply',
  'bug-report',
  'confirm-password',
  'contact-us',
  'forgot-password',
  'newsletter',
  'privacy',
  'reset-password',
  'signin',
  'signup',
]

type Props = {
  children: React.ReactNode
  persistor: Persistor
}

export default function RootLayout({ children, persistor }: Props) {
  const { dir, query } = useDirectories()
  const patreonTier = usePatreonTier()
  const [prevPatreonTier, setPrevPatreonTier] = useState(patreonTier)

  const loadAds = !patreonTier || !!query?.ads
  const showLeaderboard = loadAds && !LEADERBOARD_BLACKLIST.includes(dir)
  const showSidebar = loadAds && !SIDEBAR_BLACKLIST.includes(dir)

  // Reload page when user gains Patreon tier
  useEffect(() => {
    if (patreonTier && prevPatreonTier === undefined) {
      if (window.location.pathname === '/signin') {
        window.location.replace('/')
      } else {
        window.location.reload()
      }
    }
    setPrevPatreonTier(patreonTier)
  }, [patreonTier])

  return (
    <>
      <header>
        <Navbar persistor={persistor} />
        {loadAds && (
          <Script
            async
            data-cfasync='false'
            data-noptimize='1'
            src='//scripts.mediavine.com/tags/edhrec.js'
            type='text/javascript'
          />
        )}
      </header>
      <main className={classNames('d-flex flex-grow-1 p-3', { 'pe-lg-0': showSidebar })}>
        <div className='w-100'>
          {showLeaderboard && <Leaderboard />}
          {children}
        </div>
        {showSidebar && (
          <div className={classNames(styles.sidebar, 'mvSidebar1')}>
            <PleaseSupportUs className={styles.pleaseSupportUs} />
          </div>
        )}
      </main>
      <ScrollToTopButton />
      <Toasts />
      <Footer />
    </>
  )
}
